module.exports = __webpack_public_path__ + "static/media/Wsparcie_sprzedazy_3_B.b627d253.png";